import React, { useRef } from 'react';
import { Row, Col } from 'antd';

import { StepIcon } from './components/StepIcon';
import { HorizontalButtons } from './components/HorizontalButtons';
import { Direction, Steps } from './types';
import { Container, CustomSteps } from './styles';

export enum SIDE {
	LEFT = 'left',
	RIGHT = 'right'
}

export enum DIRECTION {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal'
}

interface StepsNavigationProps {
	steps: Steps[];
	currentStep: number;
	isComplete: boolean;
	responsive?: boolean;
	direction?: Direction;
	isConsolidated?: boolean;
	onStepNagivationClick: (step: number) => Promise<void>;
}

export const StepsNavigation: React.FC<StepsNavigationProps> = ({
	steps,
	isComplete,
	currentStep,
	responsive = true,
	onStepNagivationClick,
	isConsolidated = false,
	direction = DIRECTION.VERTICAL
}) => {
	const elementRef = useRef<HTMLDivElement | null>(null);

	const mappedSteps = steps.map((item, index) => {
		item.icon = (
			<StepIcon
				key={item.description}
				position={index}
				isComplete={isComplete}
				name={item.description}
				currentStep={currentStep}
				isConsolidated={isConsolidated}
				onStepNagivationClick={onStepNagivationClick}
			/>
		);
		return item;
	});

	if (direction === DIRECTION.VERTICAL || steps.length <= 12) {
		return (
			<Row justify="center">
				<Container xs={24}>
					<Row justify="center">
						<Col xs={20}>
							<CustomSteps
								size="small"
								items={mappedSteps}
								direction={direction}
								current={currentStep}
								responsive={responsive}
							/>
						</Col>
					</Row>
				</Container>
			</Row>
		);
	}

	return (
		<Row justify="center">
			<Container xs={24}>
				<HorizontalButtons elementRef={elementRef}>
					<Col xs={20}>
						<div ref={elementRef} style={{ overflowX: 'hidden' }}>
							<CustomSteps
								size="small"
								items={mappedSteps}
								direction={direction}
								current={currentStep}
								responsive={responsive}
							/>
						</div>
					</Col>
				</HorizontalButtons>
			</Container>
		</Row>
	);
};
